import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import _ from 'lodash';
import style from '../Debug.module.scss';

class LocationSettingsPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
    };
  }

  handleSearchInput = e => {
    const searchText = e.target.value;
    this.setState({ searchText });
  };

  filterCities(searchText) {
    const { cities, handleSelect } = this.props;
    if (!searchText || searchText === '' || !cities) return null;

    const results = _.filter(
      cities,
      city => !!_.find(city, item => _.includes(_.toLower(item.toString()), _.toLower(searchText))),
    );

    return _.map(results, city => {
      const { dmaName, callSign, dmaCode, zipCode } = city;
      return (
        <div className={style.locationResults}>
          <Link
            onClick={() => {
              handleSelect(dmaName);
            }}
          >
            {dmaName} ({callSign}/{dmaCode}/{zipCode})
          </Link>
        </div>
      );
    });
  }

  render() {
    const { handleSetLocationCookieDuration, locationCookieDuration, selectedCity } = this.props;
    const { searchText } = this.state;
    const results = this.filterCities(searchText);

    return (
      <div className={style.panel}>
        <div className={style.header}>Location Settings</div>
        <div className={style.body}>
          <div className={style.formGroup}>
            <div className={style.formLabel}>Location Cookie Duration In Days:</div>
            <div className={style.formInput}>
              <input
                type="text"
                value={locationCookieDuration}
                onChange={handleSetLocationCookieDuration}
              />
            </div>
          </div>
          <div className={style.formLabel}>Current City: {selectedCity || 'Not Set'}</div>
          <div className={style.formLabel}>Search for a city:</div>
          <input
            className={style.locationInput}
            type="text"
            value={searchText}
            onChange={this.handleSearchInput}
          />
          {results && (
            <div>
              <div className={style.formLabel}>Select a City:</div>
              {results}
            </div>
          )}
        </div>
      </div>
    );
  }
}

LocationSettingsPanel.defaultProps = {
  cities: null,
  selectedCity: null,
};

LocationSettingsPanel.propTypes = {
  cities: PropTypes.shape({
    dmaName: PropTypes.string,
    callSign: PropTypes.string,
    dmaCode: PropTypes.string,
    zipCode: PropTypes.string,
  }),
  handleSelect: PropTypes.func.isRequired,
  handleSetLocationCookieDuration: PropTypes.func.isRequired,
  locationCookieDuration: PropTypes.number,
  selectedCity: PropTypes.string,
};

export default LocationSettingsPanel;
